import template from '../../partials/address-validator.pug';
var addressValidatorDirective = function (config) {
  return {
    restrict: 'E',
    template: template,
    require: 'ngModel',
    scope: {
      'model': '=ngModel',
      'editAddress': '=',
      'selectAddress': '='
    },
    link: function (scope) {
      scope.returnText = null;
      if (scope.model.returnText) {
        scope.returnText = scope.model.returnText.replace('Default address: ', '');
      }
    }
  };
};
export default addressValidatorDirective;



//////////////////
// WEBPACK FOOTER
// ./src/js/directives/addressValidatorDirective.js
// module id = 29
// module chunks = 0